import { observer } from "mobx-react";
import React from "react";
import { useLogin } from "./useLogin";
import { useMatchedApp } from "Shared/Hooks";

const AadAuthRouteBase = (props: { children: React.ReactElement }) => {
    const matchedApp = useMatchedApp();
    useLogin(matchedApp?.torusRequired);

    return props.children;
};

export const AadAuthRoute = observer(AadAuthRouteBase);
